<template>
  <div id="unauthorized">
    <div class="container center-container">
      <div class="flex justify-center">
        <img src="../assets/img/logo.svg" alt="logo" class="logo" />
      </div>
      <div class="flex flex-column align-center sub-header">
        <p>ระบบคิวออนไลน์</p>
        <p>{{ hospitalName }}</p>
      </div>
      <div class="tutorial">
        <p class="header">กรุณาสแกน QR Code ที่บัตรคิวของท่าน</p>
        <lottie :options="defaultOptions" :height="280" :width="280">
        </lottie>
      </div>
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import * as scanQRCodeSuccessData from '../assets/img/scan-qr-code-success.json'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UnauthorizedPage',
  components: {
    Lottie
  },
  mounted () {
    this.getHospitalInfoAction()
  },
  data () {
    return {
      defaultOptions: { animationData: scanQRCodeSuccessData.default }
    }
  },
  computed: {
    ...mapState([
      'hospitalName'
    ])
  },
  methods: {
    ...mapActions([
      'getHospitalInfoAction'
    ])
  }
}
</script>

<style lang="scss" scoped>
#unauthorized {
  height: 100vh;
  display: flex;

  .center-container {
    margin: auto 0;
  }

  .logo {
    width: 150px;
  }

  .sub-header {
    font-family: 'Mitr', sans-serif;
    color: #6e6e6e;
    margin: 1rem;
  }

  .tutorial {
    max-width: 300px;
    margin: 0 auto;
    padding: 2rem;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.65);

    .header {
      font-family: 'Mitr', sans-serif;
      font-size: 1.5rem;
      text-align: center;
      color: #6e6e6e;
    }
  }
}
</style>
